// Sample fixtures shared by Administration > Support & Contacts (read-only)
// and Administration > Organisation (the screen that edits them). No backend endpoint
// exists yet for the vendor account team or the organisation's registered
// contacts, so the screen renders these and says so in its banner. Replace
// with the real API response (same field names) once it is available.
export const supportTeam = [
  {
    id: "primary",
    role: "Primary Account Manager",
    description: "Your main point of contact at Cauver.",
    name: "Punitha Natarajan",
    designation: "Account Manager",
    phone: "+91 98765 12345",
    email: "punitha@cauver.com",
    isPrimary: true,
  },
  {
    id: "backup",
    role: "Backup Support Lead",
    description:
      "Contact this person if your primary account manager is unavailable.",
    name: "Rajesh Kumar",
    designation: "Senior Account Manager",
    phone: "+91 87654 98765",
    email: "rajesh.kumar@cauver.com",
    isPrimary: false,
  },
];

export const organisationDetails = {
  organisationId: "STRCO001",
  organisationName: "STRCO India",
};

export const organisationContacts = [
  {
    id: 1,
    name: "Sadheesh Kumar",
    designation: "Director",
    phone: "+91 98765 43210",
    whatsapp: "+91 98765 43210",
    email: "sadheesh@strcoindia.com",
    contactType: "Primary",
  },
  {
    id: 2,
    name: "Priya Sharma",
    designation: "HR Manager",
    phone: "+91 87654 32109",
    whatsapp: "+91 87654 32109",
    email: "priya@strcoindia.com",
    contactType: "Secondary",
  },
  {
    id: 3,
    name: "Ramesh Babu",
    designation: "IT Manager",
    phone: "+91 99887 66554",
    whatsapp: "+91 99887 66554",
    email: "ramesh@strcoindia.com",
    contactType: "Secondary",
  },
  {
    id: 4,
    name: "Meena R",
    designation: "Finance Manager",
    phone: "+91 91234 56789",
    whatsapp: "+91 91234 56789",
    email: "meena@strcoindia.com",
    contactType: "Secondary",
  },
  {
    id: 5,
    name: "Arun Nair",
    designation: "Operations Manager",
    phone: "+91 90012 34567",
    whatsapp: "+91 90012 34567",
    email: "arun.nair@strcoindia.com",
    contactType: "Secondary",
  },
];

// "PN" for "Punitha Natarajan" — first letter of the first two words.
export const contactInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() || "")
    .join("");

// tel: links must not contain spaces.
export const phoneHref = (phone = "") => `tel:${phone.replace(/[^\d+]/g, "")}`;
export const emailHref = (email = "") => `mailto:${email}`;
